import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon, Typography, Grid } from '@material-ui/core';
import {
  PaymentOptionPropTypes,
  getCardIconByCardType,
  GiftCardPaymentOptionsPropTypes,
  formatNumberToUSD,
} from 'utils';
import DefaultAddress from './DefaultAddress';

const PaymentInfo = ({ classes, paymentMethod, gcPayments, isInstore }) => {
  let cardInfo;
  let cardTypeIcon;
  const { cardExpMonth, cardExpYear, networkType, maskedNumber, subcardType, amount } = paymentMethod;
  if (paymentMethod?.maskedNumber) {
    const last4digits = maskedNumber?.slice(-4) || '';
    const expiryDate = cardExpMonth && cardExpYear ? `, Exp ${cardExpMonth}/${cardExpYear}` : '';
    cardInfo = `${last4digits}${expiryDate}`;
    const isPLC = networkType === 'PLC';
    const cardType = isPLC && subcardType ? subcardType : networkType;
    cardTypeIcon = getCardIconByCardType(cardType);
  }

  const giftCardLabel = ({ giftCardLabel, giftCardNumber }) => {
    const giftCardLast4Digits = giftCardNumber.toString().slice(-4);
    return giftCardLabel ? `${giftCardLabel} ${giftCardLast4Digits}` : `Gift Card ${giftCardLast4Digits}`;
  };

  return (
    <Grid container direction="column" spacing={2}>
      {!!cardInfo && (
        <Fragment>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Grid container>
                <Icon className={classes.icon} component={cardTypeIcon} />
                <Typography data-testid="payment-card-info">{cardInfo}</Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography>{formatNumberToUSD(Math.max(0, amount))}</Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="h5">Billing Address</Typography>
            <DefaultAddress address={paymentMethod.billingAddress} />
          </Grid>
        </Fragment>
      )}
      {!!gcPayments.length && !isInstore && (
        <Grid item>
          <Typography variant="h5">Gift Card</Typography>
          {gcPayments.map((p, i) => (
            <Grid container justifyContent="space-between" key={p.giftCardNumber}>
              <Typography data-testid={`gift-card-number-${i}`}>{giftCardLabel(p)}</Typography>
              <Typography data-testid={`gift-card-balance-${i}`}>${p.giftCardBalance}</Typography>
            </Grid>
          ))}
        </Grid>
      )}
      {!cardInfo && !gcPayments.length && (
        <Grid item>
          <Typography>No payment option selected</Typography>
        </Grid>
      )}
    </Grid>
  );
};

PaymentInfo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  paymentMethod: PaymentOptionPropTypes,
  gcPayments: GiftCardPaymentOptionsPropTypes,
};

PaymentInfo.defaultProps = {
  classes: {},
  paymentMethod: {},
  gcPayments: [],
};

export default PaymentInfo;
